import { z } from 'zod';
import '@apexdesigner/schema-tools';
import { belongsTo, references } from '@apexdesigner/schema-tools';

export const resourceCategoryItem = z
  .object({
    id: z.number().hidden().describe('Unique identifier'),

    sequence: z
      .number()
      .nullable()
      .optional()
      .hidden()
      .describe('Sequence - Display order'),

    locked: z.boolean().nullable().optional().hidden().describe('locked'),

    resourceCategoryId: z
      .number()
      .hidden()
      .describe('Foreign key to ResourceCategory'),

    resourceId: z
      .number()
      .nullable()
      .optional()
      .presentAs('reference')
      .describe('Foreign key to Resource'),

    resourceCategory: belongsTo('ResourceCategory'),

    resource: references('Resource'),
  })
  .describe("A single resource's placement within a resource category.")
  .as('ResourceCategoryItem');

export { resourceCategoryItem as resourceCategoryItemSchema };
